import firebase from 'firebase';
let db = firebase.database();

export const fetchCoachName = (coachOrgId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const path = `coachOrgs/${coachOrgId}/coachName`;
      const name = await db.ref(path).once('value').then(s => s.val());
      resolve(name)
    } catch(e) {
      reject(e)
    }
  })
}


// WEBPACK FOOTER //
// ./src/api/analytics.api.js